export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8774.6f287fe4.jpg";